export default "/048cb1f2b29308e18768c65cfd51e426596a830c/e53673f1d35014610251dfa259b857bf.png";